import { useEffect, useMemo, useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { cn } from "../../../utils/useFunctions";
import { options_property_invest } from "../../balance/functions";
import {
  PdfBalancePropertyInvestHeaderItemCard,
  PdfBalancePropertyInvestItemCard,
  PdfCard,
  PdfCardGray,
  PdfCardWhite,
} from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { calPropertyLocalOption, getBalanceItems } from "../lib/pdf.lib";
import { STYLE_PAGE } from "../styles/pdf.style";
import { SumDebtPersonalValue } from "../../../functions/Balance/sumValueBalance";
import { sumCapitalInvest, sumDebtInvest } from "../../../functions/Balance/sumProperty";

function PdfPageBalananceTwo({ page }) {
  const balanceData = useBalanceStore((state) => state.balanceData);

    const [tempBalance, setTempBalance] = useState(balanceData);
  
  const [ReturnInsurance, setReturnInsurance] = useState([]);
  const [addInvest, setAddInvest] = useState(
      balanceData?.property_invest_list ? balanceData?.property_invest_list : []
    );

  useEffect(() => {
      if (tempBalance) {
        let tempInsuranceReturn = tempBalance?.expenses_fixed_list
          ?.filter(
            (item) => item.options_expenses_fixed === "expenses_insuarant_life"
          )
          ?.map((item) => item.expenses_insuarant_lifes)
          ?.flat();
  
        let tempBalanceData = {};
        //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//
  
        if (
          tempBalance?.property_invest_list
            ?.map((item) => item.options_property_invest_title)
            .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
          tempInsuranceReturn?.length === 0
        ) {
          // ถ้ามีหัวข้อนี้อยู่แล้ว
          let tempNameList = tempBalance?.property_invest_list
            .find(
              (item) =>
                item?.options_property_invest_title ===
                "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
            )
            ?.invest_other_lists?.filter((item) => item !== null)
            ?.map((item) => item?.title);
  
          let tempInvestList = tempBalance?.property_invest_list?.map((item) => {
            if (item?.invest_other_lists) {
              let tempData = tempInsuranceReturn
                ?.map((item2) => {
                  if (!tempNameList?.includes(item2.title))
                    return {
                      amount: item2?.more_details?.policy_surrender_value,
                      created: item2.created,
                      reward_amount_per_year: item?.reward_amount_per_year || 1,
                      target_invest: {},
                      title: item2.title,
                      editable: false,
                    };
                })
                .filter((item) => item !== undefined);
              return {
                ...item,
                invest_other_lists: [...item.invest_other_lists, ...tempData],
              };
            }
            return item;
          });
  
          tempBalanceData = tempInvestList;
        } else {
          // ถ้ายังไม่มีหัวข้อนี้อยู่
          let tempInvestList = tempInsuranceReturn?.map((item) => {
            return {
              amount: item?.more_details?.policy_surrender_value,
              created: item.created,
              reward_amount_per_year: item?.reward_amount_per_year || 1,
              target_invest: item?.target_invest || {},
              title: item.title,
              editable: true,
            };
          });
  
          tempBalanceData = tempInvestList;
        }
        setReturnInsurance(tempBalanceData);
      }
      //==============================================//
    }, [balanceData]);

  const mergeOptions = useMemo(() => {
    return [
      {
        label: "สินทรัพย์เพื่อการลงทุน",
        key: "property_invest_list",
        key_option: "options_property_invest",
        options: options_property_invest,
        icon: "investpdf.svg",
      },
    ];
  }, []);

  const propertyItems = useMemo(() => {
    let newPropertyItems = getBalanceItems(
      balanceData,
      mergeOptions,
      calPropertyLocalOption
    );


    return newPropertyItems;
  }, [balanceData]);


  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="งบดุล" icon="/images/balance.svg" />
      <PdfCard title={"สินทรัพย์"}>
        {/* สินทรัพย์ */}
        <PdfCardWhite className={"flex flex-col"}>
          {/* <PdfHeaderCardText
            title="รวมสินทรัพย์ทั้งหมด"
            titleEnd={`${numeral(
              getAllBalanceTotal(balanceData, cloneMergeOptions)
            ).format("0,0")} บาท`}
            icon=""
            classNameRoot="mt-2"
          /> */}

          <PdfBalancePropertyInvestHeaderItemCard
            title={"แหล่งที่มาของสินทรัพย์"}
          />
          <PdfLine className={"my-2"} />

          {propertyItems?.map((propertyItem, index) => {
            return (
              <div key={index} className="flex flex-col mx-2">
                <div className="flex space-x-2 items-center">
                  <div>
                    <img
                      src={`/images/${propertyItem?.icon}`}
                      className="bg-cover"
                    />
                  </div>
                  <div className="text-[11px] font-[500]">
                    {propertyItem?.label}
                  </div>
                </div>

                <PdfCardGray className={"my-1 flex flex-col space-y-2"}>
                  {propertyItem.items?.map((item, index) => {
                     let findInsuranceLife =
                        balanceData?.expenses_fixed_list?.find(
                          (item) =>
                            item?.options_expenses_fixed ===
                            "expenses_insuarant_life"
                        )?.expenses_insuarant_lifes?.reduce((acc, item) => {
                          if (item?.insurance_policy_cash_surrender) {
                            return (
                              acc +
                              Number(item?.insurance_policy_cash_surrender)
                            );
                          }
                          return acc;
                        },0);


                      let tempItem = item;
                    if (item.label === "มูลค่าเวนคืนกรมธรรม์") {
                      tempItem.amount_per_year = findInsuranceLife;

                      return (
                        <PdfBalancePropertyInvestItemCard
                          key={index}
                          item={tempItem}
                          part={"PDF"}
                          classNamePDF={"font-[500]"}
                        />
                      );
                    }

                    if (item.label === "รวม") {
                      tempItem.amount_per_year = SumDebtPersonalValue(balanceData) +
                                        sumCapitalInvest(addInvest, ReturnInsurance) +
                                        sumDebtInvest(balanceData)
                      return (
                        <PdfBalancePropertyInvestItemCard
                          key={index}
                          item={tempItem}
                          part={"PDF"}
                          classNamePDF={"font-[500]"}
                        />
                      );
                    }

                    return (
                      <PdfBalancePropertyInvestItemCard
                        key={index}
                        item={item}
                        part={"PDF"}
                        classNamePDF={"font-[500]"}
                      />
                    );
                  })}
                </PdfCardGray>
              </div>
            );
          })}
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageBalananceTwo;
